import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface SubscriptionStatusFormProps {
  formData: {
    status: string;
    cancellationDate: string;
    trialEnd?: string;
    pauseDate?: string;
    resumeDate?: string;
  };
  updateFormData: (key: string, value: any) => void;
}

export const SubscriptionStatusForm: React.FC<SubscriptionStatusFormProps> = ({
  formData,
  updateFormData,
}) => {
  return (
    <AccordionItem value="status">
      <AccordionTrigger>Status & Lifecycle</AccordionTrigger>
      <AccordionContent className="px-2">
        <div className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="status" className="text-sm font-medium">
              Status
            </Label>
            <Select
              value={formData.status}
              onValueChange={(value) => updateFormData("status", value)}
            >
              <SelectTrigger className="glass-surface">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="active">Active</SelectItem>
                <SelectItem value="trial">Trial</SelectItem>
                <SelectItem value="paused">Paused</SelectItem>
                <SelectItem value="cancelled">Cancelled</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.status === "cancelled" && (
            <div className="space-y-2">
              <Label htmlFor="cancellationDate" className="text-sm font-medium">
                Cancellation Date
              </Label>
              <Input
                id="cancellationDate"
                type="date"
                value={formData.cancellationDate}
                onChange={(e) =>
                  updateFormData("cancellationDate", e.target.value)
                }
                className="glass-surface"
              />
            </div>
          )}

          {formData.status === "trial" && (
            <div className="space-y-2">
              <Label htmlFor="trialEnd" className="text-sm font-medium">
                Trial end date
              </Label>
              <Input
                id="trialEnd"
                type="date"
                value={formData.trialEnd || ""}
                onChange={(e) => updateFormData("trialEnd", e.target.value)}
                className="glass-surface"
              />
            </div>
          )}

          {formData.status === "paused" && (
            <>
              <div className="space-y-2">
                <Label htmlFor="pauseDate" className="text-sm font-medium">
                  Pause Date
                </Label>
                <Input
                  id="pauseDate"
                  type="date"
                  value={formData.pauseDate || ""}
                  onChange={(e) => updateFormData("pauseDate", e.target.value)}
                  className="glass-surface"
                  required
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="resumeDate" className="text-sm font-medium">
                  Resume Date{" "}
                  <span className="text-muted-foreground">(optional)</span>
                </Label>
                <Input
                  id="resumeDate"
                  type="date"
                  value={formData.resumeDate || ""}
                  onChange={(e) => updateFormData("resumeDate", e.target.value)}
                  className="glass-surface"
                />
              </div>
            </>
          )}

          {formData.status === "active" && formData.pauseDate && (
            <>
              <div className="space-y-2">
                <Label htmlFor="pauseDate" className="text-sm font-medium">
                  Previously Paused On
                </Label>
                <Input
                  id="pauseDate"
                  type="date"
                  value={formData.pauseDate || ""}
                  onChange={(e) => updateFormData("pauseDate", e.target.value)}
                  className="glass-surface"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="resumeDate" className="text-sm font-medium">
                  Resumed On{" "}
                  <span className="text-muted-foreground">(optional)</span>
                </Label>
                <Input
                  id="resumeDate"
                  type="date"
                  value={formData.resumeDate || ""}
                  onChange={(e) => updateFormData("resumeDate", e.target.value)}
                  className="glass-surface"
                />
              </div>
            </>
          )}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
